import React from 'react';
import DonationData from './DonationData';

export default function Donation() {
  return (
    <div className='w-full max-w-6xl mx-auto'>
      <DonationData />
    </div>
  );
}
